// jsaConstants.js

// RAC Constants
export const racOptions = [
  { value: "E", label: "E", color: "#dc3545" }, // Red
  { value: "H", label: "H", color: "#fd7e14" }, // Orange
  { value: "M", label: "M", color: "#ffc107" }, // Yellow
  { value: "L", label: "L", color: "#28a745" }, // Green
];

export const hazardTypeTooltip = (hazardType) => {
  switch (hazardType) {
    case "Access":
      return "Heights, CSE, uneven surfaces, scaffolding";
    case "Chemical":
      return "Refering to chemicals/materials in immediate work area";
    case "Environment":
      return "Weather, noise, heat/cold, hazardous environment, power lines";
    case "Physical":
      return "Ergonomics, body positioning, lifting, pulling, pushing";
    case "Potential Energy":
      return "Stored energy sources, such as electricity, steam, or gas";
    case "Tools":
      return "Heavy machinery, tool condition, etc.";
    case "Other":
      return "Pinch points, tripping, slipping, falling, etc.";
    default:
      return "No Hazard Type Selected";
  }
};

// Fall Protection
export const fallProtectionInspectionToolTips = {
  hardwareInspection: {
    label: "Hardware",
    description:
      "Inspect for damage, distortion, sharp edges, burrs, cracks, corrosion, & proper operation",
  },
  webbingInspection: {
    label: "Webbing",
    description:
      "Inspect for cuts, tears, abrasions, fraying, discoloration, & excessive soiling",
  },
  stitchingInspection: {
    label: "Stitching",
    description: "Inspect for loose, frayed, or broken stitching",
  },
  syntheticRopeInspection: {
    label: "Synthetic Rope",
    description:
      "Inspect for pulled or cut yarns, burns, abrasion, knots, excessive soiling, & discoloration",
  },
  wireRopeInspection: {
    label: "Wire Rope",
    description:
      "Inspect for broken wires, corrosion, kinks, & separation of strands",
  },
  energyAbsorbInspection: {
    label: "Energy Absorb",
    description: "Inspect for elongation, tears, & excessive soiling",
  },
  labelsInspection: {
    label: "Labels",
    description:
      "Make certain all labels are securely held in place and legible",
  },
};

// Map of section names to their checkbox attributes
export const SECTION_ATTRIBUTES = {
  showCseSection: [
    "csSurveyed",
    "csAirMon",
    "csReSys",
    "csTrainedPerson",
    "csCompPerson",
    "csRiskAssess",
    "csRescue",
    "csComms",
  ],
  showElectricalSection: [
    "elecLoto",
    "elecGrounded",
    "elecPanelCover",
    "elecGfciExtCord",
    "elecPtCordInsp",
    "elecOverheadLine",
    "elecWarningSigns",
    "elecSpotter",
    "elecHandHydroExcav",
  ],
  showEquipmentSection: [
    "equipSuitable",
    "equipInspLift",
    "equipWarningDev",
    "equipSeatBelts",
    "equipExcZone",
    "equipPedRoute",
    "equipFencing",
    "equipGuzzlerSafety",
    "equipSafeWorkLoad",
    "equipLockAttach",
    "equipFlagger",
    "equipRigger",
    "equipSpeedSign",
    "equipNoPass",
    "equipNoCellphone",
  ],
  showExcavationSection: [
    "excavSloping",
    "excavShoring",
    "excavTrenchBox",
    "excavBarricades",
    "excavCompPerson",
    "excavBuriedUtil",
    "excavInspection",
    "excavExcZone",
    "excavUndermining",
    "excavSpoilsMin",
    "excavVehWheelChock",
    "excavAdequateAccess",
    "excavHoleCover",
    "excavWarningSigns",
    "excavMatEdgeStorage",
  ],
  showFallProtectionSection: [
    "fallHarnessLanyard",
    "fallAdequateAnchor",
    "fallGuardrail",
    "fallCoveredOpenings",
    "fallFixedBarricades",
    "fallWarningSystem",
  ],
  showFireProtectionSection: [
    "fireExtinguisher",
    "fireWatch",
    "fireNonsparkTools",
    "fireGrounding",
    "fireIntrinSafeEquip",
  ],
  showHandToolsSection: [
    "htSuitability",
    "htVoltageKnown",
    "htInspectCord",
    "htFuncGuard",
    "htGeneratorOut",
    "htToolsRep",
  ],
  showHeatColdStressSection: [
    "hcWorkRest",
    "hcRestArea",
    "hcLiqAvail",
    "hcMonitoring",
    "hcTraining",
  ],
  showInspectionsSection: [
    "inspLadAerial",
    "inspLanHarness",
    "inspScaffold",
    "inspHeavyEquip",
    "inspCraneRig",
  ],
  showMedicalSection: [
    "medFirstAid",
    "medEyeWash",
    "medCpr",
    "medHopsitalRoute",
  ],
  showPermitsSection: [
    "permHotWork",
    "permConfinedSpace",
    "permLoto",
    "permExcavation",
    "permDemo",
    "permEnergized",
  ],
  showPpeSection: [
    "ppeThermal",
    "ppeEye",
    "ppeDermalHand",
    "ppeHearing",
    "ppeRespirator",
    "ppeSuppAir",
    "ppeApr",
    "ppeControlAprCart",
    "ppeRefVest",
    "ppeFloatation",
    "ppeHardHat",
    "ppeWorkboot",
  ],
  showPopSection: [
    "popFencing",
    "popCoveredWalkway",
    "popBarriers",
    "popPedWalkway",
    "popWarningSigns",
    "popSecurity",
    "popFlagger",
  ],
  showTrainingSection: [
    "trainHazwoper",
    "trainConstruction",
    "trainCompPerson",
    "trainTaskSpecific",
    "trainHazcom",
  ],
  showVehicleTrafficSection: [
    "vtTrafControl",
    "vtBarricades",
    "vtFlags",
    "vtSigns",
  ],
  showWeldingCuttingSection: [
    "wcCylinderSec",
    "wcCylinderSep",
    "wcFbArrestor",
    "wcNoCylCse",
    "wcFlamRetCloth",
    "wcAppGoggles",
  ],
};
